// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { S } from './styles';

interface animationProps extends React.ComponentPropsWithoutRef<'div'>{
  size?: number;
  thickness?: number;
}

export default function AutoplayAnimation(props: animationProps): JSX.Element {
  const {
    size = 193,
    thickness = 20,
    ...otherProps
  } = props;

  const r = size / 2 - thickness / 2;
  const cxy = size / 2;

  return (
    <S.Container {...otherProps}>
      <svg
        width={size}
        height={size}>
        <circle
          stroke="#848484"
          strokeWidth={thickness}
          fill="transparent"
          r={r}
          cx={cxy}
          cy={cxy} />
        <S.ProgressRingCircle
          stroke="white"
          strokeWidth={thickness}
          fill="transparent"
          r={r}
          cx={cxy}
          cy={cxy} />
      </svg>
      <S.PlayIcon />
    </S.Container>
  )
}
